import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
/**
 * Colors_T35.jsx - Vibrant Explorer Theme
 * Palette: Electric Indigo + Coral + Cyan + Emerald
 */

export const mapB2CTenantToLanding = (tenantData) => {
  const theme  = tenantData?.theme  || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero   = tenantData?.hero   || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:  tenantData?.companyId,
    branchId:   tenantData?.branchId,
    userId:     tenantData?.userId,
    logoUrl:    getLocalLogoUrl(tenantData?.domain),
    brandName:  tenantData?.branding?.brandName || 'Travel Agency',
    email:      tenantData?.branding?.email     || 'support@agency.com',
    phones:     Array.isArray(tenantData?.branding?.phones) ? tenantData?.branding?.phones[0] : tenantData?.branding?.phones || '9128341203',
    whatsapp:   tenantData?.branding?.whatsapp  || '9128341203',
    socials:    tenantData?.branding?.socials   || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,

    topBarBg:   topBar.bgColor   || theme.themeColor1 || theme.themecolor1,
    topBarText: topBar.textColor || '#ffffff',

    headerBg:   header.bgColor   || theme.themeColor3 || 'rgba(255,255,255,0.95)',
    headerText: header.textColor || '#1A1033',

    footerBg:   footer.bgColor   || theme.themeColor2 || theme.themecolor2 || '#1A1033',
    footerText: footer.textColor || '#ffffff',

    heroData: {
      flights: {
        title:     hero.flights?.title     || 'Your Journey Begins Here.',
        subTitle:  hero.flights?.subTitle  || 'Discover the world\'s best flights at unbeatable prices.',
        textColor: hero.flights?.textColor || '#ffffff',
        bgImage:   hero.flights?.bgImage   || 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=1600',
      },
      hotels: {
        title:     hero.hotels?.title     || 'Find Your Perfect Stay.',
        subTitle:  hero.hotels?.subTitle  || 'Luxury, comfort and value — all in one place.',
        textColor: hero.hotels?.textColor || '#ffffff',
        bgImage:   hero.hotels?.bgImage   || 'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=1600',
      },
      holidays: {
        title:     hero.holidays?.title     || 'Dream It. Book It. Live It.',
        subTitle:  hero.holidays?.subTitle  || 'Handpicked holiday packages for every kind of traveler.',
        textColor: hero.holidays?.textColor || '#ffffff',
        bgImage:   hero.holidays?.bgImage   || 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1600',
      },
      sightseeing: {
        title:     hero.sightseeing?.title     || 'Explore, Experience, Remember.',
        subTitle:  hero.sightseeing?.subTitle  || 'Book world-class activities and guided tours.',
        textColor: hero.sightseeing?.textColor || '#ffffff',
        bgImage:   hero.sightseeing?.bgImage   || 'https://images.unsplash.com/photo-1501854140801-50d01698950b?q=80&w=1600',
      },
    },
  };
};

export const getB2CColors_T35 = (landingData) => {
  const c1 = landingData.themeColor1 || '#6C63FF'; // Electric Indigo (primary)

  return {
    theme1: c1,
    theme2: landingData.footerBg || '#1A1033',      // Deep Space (footer / dark bg)
    theme3: landingData.headerBg || '#ffffff',       // White header
    theme4: landingData.themeColor4 || '#F8F7FF',   // Soft lavender background
    theme5: landingData.themeColor5 || '#ffffff',    // Text on dark bg

    // Extended palette — always derived from c1 or fixed accents
    coral:   '#FF6B6B',  // Coral accent
    cyan:    '#00D4FF',  // Electric cyan
    emerald: '#06D6A0',  // Emerald green
    amber:   '#FFD166',  // Warm amber

    headerText: landingData.headerText || '#1A1033',
    footerText: landingData.footerText || '#ffffff',

    topBarBg:   landingData.topBarBg   || '#6C63FF',
    topBarText: landingData.topBarText || '#ffffff',

    // Gradient helpers
    gradientPrimary: `linear-gradient(135deg, #6C63FF 0%, #a855f7 50%, #ec4899 100%)`,
    gradientHero:    `linear-gradient(135deg, rgba(108,99,255,0.85) 0%, rgba(168,85,247,0.75) 100%)`,
  };
};
